import React from 'react';
import { Modal, Box, Button } from '@mui/material';

interface ForceSubmitConfirmModalProps {
    studentIds: number[] | null;
    onConfirm: (ids: number[]) => void;
    onClose: () => void;
}

const ForceSubmitConfirmModal: React.FC<ForceSubmitConfirmModalProps> = ({
    studentIds,
    onConfirm,
    onClose,
}) => (
    <Modal open={studentIds !== null} onClose={onClose}>
        <Box sx={{ p: 4, bgcolor: 'background.paper', margin: 'auto', mt: 8, width: 400 }}>
            <h2>Force Submit</h2>
            <p style={{ marginTop: 16 }}>
                Are you sure you want to force submit {studentIds?.length ?? 0} student
                {(studentIds?.length ?? 0) !== 1 ? 's' : ''}?
            </p>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
                <Button variant="outlined" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="warning"
                    onClick={() => {
                        if (studentIds) onConfirm(studentIds);
                    }}
                >
                    Force Submit
                </Button>
            </Box>
        </Box>
    </Modal>
);

export default ForceSubmitConfirmModal;
